import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium'
import $ from 'jquery'

class NumberInput extends Component {
  constructor(props) {
    super(props);
    this.state ={
      value: (props.placeHolder) ? '' : '0',
      oldValue: null
    };
  }

  componentDidMount = () => {


    if (this.props.value!==undefined){
      if (this.props.forceFocus) {
        $(this.refs.input).focus().val("").val(this.props.value);
      }
      else {
        let val = this.props.value.toString().replace('.', ',')
        this.setState({
          value: val
        })
        //if flag is set for not update on mount, do nothing
        if(this.props.shouldNotCallOnChangeOnMount) return;
        this.props.onChange(this.props.value);
        return;
      }
    }
    if (this.props.defaultValue !== undefined){
        let val = this.props.defaultValue===null ?'' :
          this.props.defaultValue.toString().replace('.', ',')
        this.setState({
          value: val
        })
        //if flag is set for not update on mount, do nothing
        if(this.props.shouldNotCallOnChangeOnMount) return;
        this.props.onChange(this.props.defaultValue);
    }
    else{
      let val = this.props.placeHolder ? null : 0;
      //if flag is set for not update on mount, do nothing
      if(this.props.shouldNotCallOnChangeOnMount) return;
      this.props.onChange(val);
    }
  };

  componentWillReceiveProps = (nextProps) => {
     // eslint-disable-next-line
    if (nextProps.value!=undefined){
      if(nextProps.value.toString()===this.state.value.replace(',', "")) return;
      this.setState({
        value: nextProps.value.toString().replace('.', ',')
      })
    } else if (nextProps.value==null) {this.setState({value: ''})}
  };

  onEnterPress = (e) => {
    if(this.props.onEnterPress)
     if(e.which===13)
     {
        this.props.onEnterPress();
     }
  };

  onChange =(evt) => {
    //strip everything else than numbers and comma
    var trimmed = evt.target.value.replace(/[^0-9,.]/g, '');
    trimmed = trimmed.replace(".", ",");
    // you can't start input with a comma
    if (trimmed===",") {trimmed = "";}
    // split and resemble
    var splits = trimmed.split(",");
    trimmed = splits[0];
    if (splits.length >= 2){
      trimmed += ",";
      for(let i=1; i < splits.length; i++){
          trimmed += "" + splits[i] + "";
        }
    }
    if (trimmed !== this.state.value){
      this.setState({value: trimmed});
      if(trimmed==="" && !this.props.disableClearOnEnter) {trimmed = "0";}
      else if(trimmed==="" && this.props.disableClearOnEnter){
        this.props.onChange(null)
        return;
      }

      this.props.onChange(parseFloat(trimmed.replace(',', '.')))
    }
  };

  clearInput = () => {
    if(this.props.disableClearOnEnter) return;
    this.setState({
      oldValue: this.state.value,
      value: ''
    });
  };

  resetInputToOldVal = () => {
    if(this.props.onBlur)
      this.props.onBlur();
    if(this.props.disableClearOnEnter) return;
    if (this.state.value === ''){
      var oldValue = this.state.oldValue;
      this.setState({
          value: oldValue,
          oldValue: null
      });
    }
  };
  render() {
    return (
      <input
        ref="input"
        placeholder={this.props.placeHolder}
        disabled={this.props.isDisabled}
        onChange={this.onChange}
        onClick={this.clearInput}
        onBlur={this.resetInputToOldVal}
        style={[styles.input, this.props.style && this.props.style]}
        type="tel"
        value={this.state.value}
        onKeyPress={this.onEnterPress}
         />
    );
  }
}

var styles = {
  input: {
    '-webkit-appearance': 'none',
    width:' 100%',
    border: 'none',
    textAlign: 'right',
    cursor: 'pointer',
    display: 'block',
    paddingRight: 8,
  }
}
  NumberInput.propTypes = {
    defaultValue: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    onBlur: PropTypes.func,
    placeHolder: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.number,
    disableClearOnEnter: PropTypes.bool,
    forceFocus: PropTypes.bool,
    onPressEnter: PropTypes.func,
    shouldNotCallOnChangeOnMount: PropTypes.bool
  };


export default Radium(NumberInput);



// WEBPACK FOOTER //
// ./src/App/Common/numberInput.jsx